"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const safe_get_1 = require("../../../../../libs/safe-get");
exports.exportData = {
    export(data, state) {
        const contentData = exports.exportData.getContentData(state, data);
        const tabNames = Object.keys(contentData);
        return tabNames.reduce((state, tabName) => {
            return Object.assign({}, state, { [tabName]: Object.assign({}, (state[tabName] || {}), { active: contentData[tabName] }) });
        }, data);
    },
    getContentData(state, data) {
        const defaultInherit = undefined;
        const defaultHide = false;
        const defaultWidth = getDimensionAttrValue(state.tabs.default.containerDimensions.widthValue, state.tabs.default.containerDimensions.widthFormat);
        const defaultHeight = getDimensionAttrValue(state.tabs.default.containerDimensions.heightValue, state.tabs.default.containerDimensions.heightFormat);
        const defaultStyle = exports.exportData.getStyleText({
            initialStyle: safe_get_1.safeGet(() => data.default.active.attributes.style) || '',
            widthFormat: state.tabs.default.containerDimensions.widthFormat,
            widthValue: state.tabs.default.containerDimensions.widthValue,
            heightFormat: state.tabs.default.containerDimensions.heightFormat,
            heightValue: state.tabs.default.containerDimensions.heightValue,
        });
        const defaultSrc = state.tabs.default.imageUrl;
        const defaultAlt = state.tabs.default.imageAlternativeText;
        const defaultImagePorperties = {
            inherit: defaultInherit,
            hide: defaultHide,
            attributes: {
                width: defaultWidth,
                height: defaultHeight,
                style: defaultStyle,
                src: defaultSrc,
                alt: defaultAlt,
            },
        };
        const mobileInherit = state.tabs.mobile.imageVisibilityState === 'inherit' ? 'default' : undefined;
        const mobileHide = state.tabs.mobile.imageVisibilityState === 'hideImage';
        const mobileWidth = getDimensionAttrValue(state.tabs.mobile.containerDimensions.widthValue, state.tabs.mobile.containerDimensions.widthFormat);
        const mobileHeight = getDimensionAttrValue(state.tabs.mobile.containerDimensions.heightValue, state.tabs.mobile.containerDimensions.heightFormat);
        const mobileStyle = exports.exportData.getStyleText({
            initialStyle: safe_get_1.safeGet(() => data.mobile.active.attributes.style) || '',
            widthFormat: state.tabs.mobile.containerDimensions.widthFormat,
            widthValue: state.tabs.mobile.containerDimensions.widthValue,
            heightFormat: state.tabs.mobile.containerDimensions.heightFormat,
            heightValue: state.tabs.mobile.containerDimensions.heightValue,
        });
        const mobileSrc = state.tabs.mobile.imageUrl;
        const mobileAlt = state.tabs.mobile.imageAlternativeText;
        const mobileImageProperties = {
            inherit: mobileInherit,
            hide: mobileHide,
            attributes: {
                width: mobileWidth,
                height: mobileHeight,
                style: mobileStyle,
                src: mobileSrc,
                alt: mobileAlt,
            },
        };
        return {
            default: defaultImagePorperties,
            mobile: mobileImageProperties,
        };
    },
    getStyleText({ initialStyle, widthFormat, widthValue, heightFormat, heightValue, }) {
        const parser = new DOMParser();
        const doc = parser.parseFromString('<div />', 'text/html');
        const div = doc.querySelector('div');
        div.style.cssText = initialStyle;
        if (widthValue && widthFormat && widthFormat !== 'auto') {
            div.style.setProperty('width', `${widthValue}${widthFormat}`, div.style.getPropertyPriority('width'));
        }
        if (heightValue && heightFormat && heightFormat !== 'auto') {
            div.style.setProperty('height', `${heightValue}${heightFormat}`, div.style.getPropertyPriority('height'));
        }
        return div.style.cssText;
    },
};
function getDimensionAttrValue(value, format) {
    if (format !== 'px' || value === undefined) {
        return '';
    }
    return '' + value;
}
//# sourceMappingURL=export-data.js.map